import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { I18N } from '../../utils/i18n/i18n';

@Component
export default class Internationalizer extends Vue {
   public title: string = 'Internationalizer';

   public data = I18N.selectorFactory();

   public model = this.currentLocale();
   public updateQueryStringParameter(uri: string, key: string, value: string) {
      const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
      const separator = uri.indexOf('?') !== -1 ? '&' : '?';
      if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2');
      } else {
        return uri + separator + key + '=' + value;
      }
   }
   public onChange(item: any) {
      this.$i18n.locale = I18N.selectorFactory().find((v: any) => v.value === item)!.key;
      if (this.$i18n.locale === 'en') {
         location.href = this.updateQueryStringParameter(location.href, 'ltype', '1');
      }
      if (this.$i18n.locale === 'zh-cn') {
         location.href = this.updateQueryStringParameter(location.href, 'ltype', '0');
      }
   }

   public currentLocale() {
      return I18N.selectorFactory().find((v: any) => v.key === this.$i18n.locale)!.value;
   }
}
